import { Component } from '@angular/core';
import { AppState } from '../../config/state';
import { LoginProvider } from '../../providers/login/login';
import { Events, PopoverController, NavController } from 'ionic-angular';
import { CoSignOutPopoverComponent } from '../co-sign-out-popover/co-sign-out-popover';
import { SoundsProvider } from '../../providers/sounds/sounds';

/**
 * Generated class for the CoLoggedInIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-logged-in-icon',
  templateUrl: 'co-logged-in-icon.html'
})
export class CoLoggedInIconComponent {

  text: string;
  loggedIn: boolean;
  patronInfo: any;
  sharedScreen: boolean = false;
  constructor(private state: AppState, private login : LoginProvider, private events : Events, private popoverCtrl: PopoverController, private navCtrl : NavController, private sounds : SoundsProvider) {
    this.sharedScreen = this.state.sharedScreen;
    if (this.state.loggedInPatronId && this.state.loggedInPatronId !== null){
      this.login.getCurrent().then(pat => {
        this.patronInfo = pat;
        this.loggedIn = true;
        // console.log(pat);
      });
    } else {
      this.loggedIn = false;
    }
    this.events.subscribe('patronLoggedIn', (login)=>{
      // console.log('patronLoggedIn called', login)
      this.loggedIn = login;
      if (login){
        this.setPatronInfo();
      }else{
        this.patronInfo = null;
      }
    });
  }
  ngAfterViewChecked(){
    if(this.state.patron && !this.patronInfo && !this.loggedIn){
      // console.log('ngAfterViewChecked');
      this.setPatronInfo();
    }else if(!this.state.patron && this.loggedIn){
      setTimeout(()=>this.logoutFromButton(true), 50);
    }
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  setPatronInfo(){
    this.login.getCurrent().then(pat => {
      this.loggedIn = true;
      this.patronInfo = pat;
      // console.log(pat);
    });
  }

  logoutFromButton(dontPop?){
    this.sounds.playSoundOnButtonClick();
    this.loggedIn = false;
    this.patronInfo = false;
    if(!dontPop)this.login.logout();
    this.navCtrl.popToRoot();
  }

  openLogout(event){
    let popup = this.popoverCtrl.create(CoSignOutPopoverComponent, {}, {cssClass: 'sign-out-popup'});
    popup.present({ev: event});

    popup.onDidDismiss( data =>{
      // console.log(data);
      if (data && data.logout){
        this.navCtrl.popToRoot();
      }

    });
  }



}



// WEBPACK FOOTER //
// ./src/components/co-logged-in-icon/co-logged-in-icon.ts